// BNB
export const DEFAULT_INPUT_CURRENCY = 'BNB'
// BUSD
export const DEFAULT_OUTPUT_CURRENCY = '0x119207c59b195BA0869Dc93b725fDF4215C99A6C'
